import { z } from 'zod';
/**
 * Session contract between the web/mobile apps and POST /auth/login, /auth/refresh, /auth/me.
 *
 * The access token is returned in the body and kept in memory by the client. The refresh token
 * is NEVER returned in the body: it travels in an httpOnly, SameSite=strict cookie scoped to the
 * /api/v1/auth path, so scripts cannot read it and it is not sent with ordinary API requests.
 */
export const loginRequestSchema = z.object({
    email: z.string().email().max(254),
    password: z.string().min(1).max(200),
    /** Optional: sign in to a specific organization when the user belongs to several. */
    organizationId: z.string().uuid().optional(),
});
/** Name of the httpOnly cookie carrying the refresh token. */
export const REFRESH_TOKEN_COOKIE = 'ashniva_refresh';
export const acceptInvitationSchema = z.object({
    token: z.string().min(20).max(200),
    name: z.string().min(2).max(120).optional(),
    password: z.string().min(12).max(200),
});
export const forgotPasswordSchema = z.object({ email: z.string().email().max(254) });
export const resetPasswordSchema = z.object({
    token: z.string().min(20).max(200),
    password: z.string().min(12).max(200),
});
export const REAUTH_HEADER = 'x-reauth-token';
//# sourceMappingURL=auth.js.map